import { useCallback, useRef } from 'react';

// todo check is it works
export function useThrottle(callback, delay: number) {
  const lastCall = useRef(0);

  const throttledCallback = useCallback(
    (...args) => {
      const now = Date.now();
      if (now - lastCall.current >= delay) {
        lastCall.current = now;
        callback(...args);
      }
    },
    [callback, delay],
  );

  return throttledCallback;
}
